export default __webpack_public_path__ + "static/media/activeFilter.018566dc.svg";